import { render, staticRenderFns } from "./AttendanceBulkAddDialog.vue?vue&type=template&id=3dd45536&scoped=true"
import script from "./AttendanceBulkAddDialog.vue?vue&type=script&lang=js"
export * from "./AttendanceBulkAddDialog.vue?vue&type=script&lang=js"
import style0 from "./AttendanceBulkAddDialog.vue?vue&type=style&index=0&id=3dd45536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd45536",
  null
  
)

export default component.exports